export type NavLinkKey =
  | "Staking"
  | "Prices"
  | "CreditCard"
  | "Derivatives"
  | "Perpetuals"
  | "TokenizedStocks"
  | "Products"
  | "Institutions"
  | "Resources";

export const NAV_LINK_KEYS: Record<NavLinkKey, NavLinkKey> = {
  Staking: "Staking",
  Prices: "Prices",
  CreditCard: "CreditCard",
  Derivatives: "Derivatives",
  Perpetuals: "Perpetuals",
  TokenizedStocks: "TokenizedStocks",
  Products: "Products",
  Institutions: "Institutions",
  Resources: "Resources"
} as const;
